<template>
    <page>
        <print-queue-table v-if="dataLoaded" :print-groups="printGroups" variant="printed" @updated="getPrintGroups"/>
    </page>
</template>

<script>
import Page from '@/components/Page'
import PrintQueueTable from './components/PrintQueueTable'

export default {
    components: {Page, PrintQueueTable, },
    data() {
        return {
            printGroups: [],
            dataLoaded: false,
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Daily Payroll / Printed')
        this.getPrintGroups()
    },
    methods: {
        getPrintGroups() {
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/daily-payroll/printed').then(resp => {
                this.printGroups = resp.print_groups
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
